var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex p-2 space-x-2"},_vm._l((_vm.filters),function(filter){return _c('button',{key:filter.id,class:[
      'px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ease-in-out',
      _vm.activeFilter === filter.id
        ? 'bg-black text-white'
        : 'bg-white text-gray-700 hover:bg-gray-200'
    ],on:{"click":function($event){return _vm.setActiveFilter(filter.id)}}},[_vm._v(" "+_vm._s(filter.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }